import { sharedConfig } from '@/pageConfig/shared';
import ogImage from '@/static/assets/faq/nl/og.png';
import { Faq } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/Faq/faq__nl-NL.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

const QAPageJsonld = {
  '@context': 'http://schema.org/',
  '@type': 'WebPage',
  breadcrumb: 'Lemonade.com > Lemonade FAQ',
  name: 'Lemonade FAQ',
  image:
    'https://www.lemonade.com/assets/lemonade-share-image-ad9d7846f31685bfb4af89f018e4dd5d460f4e73768a8fd500bfc1f069ff853a.png',
  description:
    "Lees hier een aantal van Lemonade's veelgestelde vragen - van wat aansprakelijkheidsverzekering eigenlijk is, tot wat je inboedelverzekering precies dekt.",
};

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['nl-NL'].layout },
  seo: {
    title: 'Inboedel en aansprakelijkheidsverzekering FAQ • Lemonade Verzekeringen NL',
    metaTitle: 'Inboedel en aansprakelijkheidsverzekering FAQ • Lemonade Verzekeringen NL',
    description:
      'Hier vind je antwoorden op jouw dekkingsvragen - van wat inboedel en aansprakelijkheidsverzekering eigenlijk is, tot wat deze dekt.',
    jsonld: [QAPageJsonld],
    ogImage: ogImage.src,
  },
  MDXContent: content as Faq,
};
